import { Button, Group, Modal, Text } from '@mantine/core'
import React from 'react'
import { useAppContext } from '../../../context/AppState/AppContext';

export default function TransferBankConfirmModal({ setModal, modal, TransferBankConfirmModalTxt, ...others }) {
   const {title, subtitle, confirmationButton, goBackButton} = TransferBankConfirmModalTxt;
   const { jsonColors } = useAppContext();
   return (
      <Modal opened={modal} withCloseButton={false}
         onClose={() => setModal(false)}
         >
         <Group gap={"md"}>

            <Group justify="center">

               <div style={{ width: "90%", display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  <Text ta={'center'} style={{ fontSize: 'var(--fs-h3)', lineHeight: '1.2' }}>{title}</Text>
                  <Text ta={'center'} style={{ fontSize: 'var(--fs-small)', lineHeight: 'var(--fs-small)' }}>
                     {subtitle}
                  </Text>
               </div>

            </Group>

            <Group justify="center" w={'100%'} style={{ marginTop: '16px' }}>
               <Button variant="subtle" onClick={() => setModal(false)}>
                  {goBackButton}
               </Button>
               <Button color={jsonColors.tertiary} {...others}>{confirmationButton}</Button>
            </Group>
         </Group>
      </Modal>
   )
}
